import AccountDeleteComponent from "../Components/AccountDelete/index";

const AccountDelete = () => {
  return <AccountDeleteComponent />;
};
export default AccountDelete;
